import { render } from "./PerformanceOfAgents.vue?vue&type=template&id=2c1db4b0&ts=true"
import script from "./PerformanceOfAgents.vue?vue&type=script&lang=ts"
export * from "./PerformanceOfAgents.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__